import Icon from '../components/Icon.vue'

Icon.register({
  'caret-square-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 480h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM259.5 124.5l-123 123c-4.7 4.7-4.7 12.3 0 17l123 123c7.6 7.6 20.5 2.2 20.5-8.5v-246.1c0-10.7-12.9-16-20.5-8.5z'
      }
    ]
  }
})
